import { ShipmentView } from '../../models/shipment-view';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';
import { DocumentStateEnum } from '../../enum/document-state.enum';
import { Document } from '../../models/document';
import { selectProfileIdentityName, selectShipmentViews } from '../profile/profile.state';
import { ExportFormatEnum } from '../../enum/export-format.enum';
import { ExportProviderEnum } from '../../enum/export-provider.enum';
import { RouteData } from '../../models/route-data';
import { selectRouteParam, selectRouteParamDeep } from '../router/router.state';
import { shipmentNumber } from '../../utils/shipment-number';
import { SearchResult } from '../../models/search-result';

export interface InterfaceState {
    currentView?: string;
    documentState?: DocumentStateEnum;
    document?: Document;
    exporting: boolean;
    exportFormats: ExportFormatEnum[];
    exportProvider?: ExportProviderEnum;
    exportProgress?: number;
    routeData: RouteData;
    searchTerm: string;
    searchResults: SearchResult[];
    searchActive: boolean;
}

export const selectInterfaceState = (state: AppState) => state.interface;

export const selectCurrentShipmentView = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.currentView);

export const selectDocumentState = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.documentState);

export const selectDocument = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.document);

export const selectExportBusy = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.exporting);

export const selectExportFormats = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.exportFormats);

export const selectExportProvider = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.exportProvider);

export const selectExportProgress = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.exportProgress);

export const selectRouteTitle = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.routeData.title);

export const selectCreateEntity = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.routeData.createEntity );

export const selectDisplayTitle = createSelector(
    selectRouteTitle, selectProfileIdentityName, selectRouteParamDeep('id'),
    (text, identityName, routeId) => {
        if (text && text.indexOf('%') !== -1) {
            text = text.replace('%', shipmentNumber(routeId));
        }
        return text || identityName;
    }
);

export const selectShipmentEditorRoute = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.routeData.shipmentEditor);

export const selectGlobalSearchResults = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.searchResults);

export const selectGlobalSearchActive = createSelector(selectInterfaceState,
    (state: InterfaceState) => state.searchActive);
